import React from 'react'

import TicketSelectBranchFilter from './TicketSelectBranchFilter'
import TicketSelectBranchList from './TicketSelectBranchList'
import TicketSelectBranchPagination from './TicketSelectBranchPagination'

import type { ITicketSelectBranch } from './model'

const TicketSelectBranch: React.FC<ITicketSelectBranch> = (
  props: ITicketSelectBranch,
) => {
  const {
    branches,
    isLoading,
    isError,
    setSearchParams,
    searchParams,
    totalPage,
    currentPage,
  } = props

  const ticketSelectBranchFilterProps = {
    isLoading,
    searchParams,
    setSearchParams,
  }

  const ticketSelectBranchList = {
    isLoading,
    isError,
    branches,
    setSearchParams,
    searchParams,
  }

  const ticketSelectBranchPaginationProps = {
    currentPage,
    totalPage,
    disabled: false,
    setSearchParams,
  }

  return (
    <>
      <TicketSelectBranchFilter {...ticketSelectBranchFilterProps} />
      <TicketSelectBranchList {...ticketSelectBranchList} />
      <TicketSelectBranchPagination {...ticketSelectBranchPaginationProps} />
    </>
  )
}

export default TicketSelectBranch
